export default class UsersPrivilegeExpenses {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.expensesAdd = false;
    this.expensesRefund = false;
    this.expensesView = false;
  }
  fillData(data) {
    this.expensesAdd = data.expensesAdd;
    this.expensesRefund = data.expensesRefund;
    this.expensesView = data.expensesView;
  }
}
